export interface SessionInfo {
  sessionId: string;
  userId: string;
  searchId?: string;
}

export interface SearchRequest {
  searchType: string;
  make?: string | null;
  model?: string | null;
  year?: string | null;
  state: string;
  mileage: string;
  vin?: string | null;
  licensePlate?: string | null;
  invalidSearch: InvalidSearch | null;
}

export interface InvalidSearch {
  reason: string;
  message: string;
}

export interface SearchParams {
  make?: string | null;
  model?: string | null;
  year?: string | null;
  mileage: string;
  state: string;
  userId: string | null;
  searchId: string | null;
  sessionId: string | null;
  filters: Filters;
  sorting: Sorting;
  duration: MinMaxValue;
  searchSource: string;
  searchType: string;
}

export interface Sorting {
  isRecommended: number;
  price: number;
  rating: number;
}

export interface MinMaxValue {
  MaxValue: number;
  MinValue: number;
}

export interface FromToValue {
  from: number;
  to: number;
}

export interface Filters {
  rating: number[];
  monthlyPrice: FromToValue;
  duration: FromToValue;
  miles: FromToValue;
}

//Types
export const SEARCH_TYPES = {
  VIN: 'vin',
  MAKEMODEL: 'makemodel',
  LICENSEPLATE: 'licenseplate',
} as const;

export type SearchTypes = ObjectValues<typeof SEARCH_TYPES>;
